<template>
  <v-dialog :width="width" @click:outside="closeModal">
    <v-card class="rounded-lg h-auto bg-white py-5 px-5">
      <div class="flex flex-col items-center">
        <img
          :src="require(`../assets/icon/${img}`)"
          alt="icon"
          class="w-10 h-auto mb-4 mt-3"
        />
        <h3 class="mb-2 text-base font-semibold">{{ title }}</h3>
        <p class="text-center text-xs text-gray-500" v-html="description"></p>
      </div>

      <slot></slot>

      <div class="grid grid-cols-2 gap-3 mt-3">
        <FormButton
          @click="closeModal"
          classes="capitalize text-xs text-gray-500"
          :label="wordingCancel"
          variant="outlined"
        />

        <FormButton
          classes="capitalize text-xs font-medium bg-red-600 text-white"
          :label="loading ? 'Memproses...' : wordingConfirm"
          @click="doConfirm"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import FormButton from "./FormButton.vue";

export default {
  name: "ConfirmModal",
  components: { FormButton },
  props: {
    img: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true },
    width: { type: [String, Number], default: 350 },
    wordingConfirm: { type: String, default: "Ya" },
    wordingCancel: { type: String, default: "Tidak" },
    loading: { type: Boolean, default: false },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    doConfirm() {
      this.$emit("confirm-data");
    },
  },
};
</script>
